import { onAbort, withTimeout } from './fetchTimeout';

export type WebfingerResponse = {
  subject: string;
  links: {
    rel: string;
    href: string;
    properties: Record<string, string>;
    titles: Record<string, string>;
  }[];
};

type IdpItem = {
  title: string;
  id: string;
};

type IdpInfo = {
  idpList: IdpItem[];
  isPasswordSignInAvailable: boolean;
};

export const getIdpFromWebfinger: (
  baseUrl: string,
) => (username?: string) => Promise<IdpInfo | undefined> =
  (baseUrl) => async (username) => {
    const fetcher = withTimeout(5000, fetch);
    const webfingerResponse = fetcher(
      `${baseUrl}/api/v1/.well-known/webfinger?resource=acct:${username}`,
      {
        headers: new Headers({
          Accept: 'application/jrd+json',
        }),
      },
    );
    // return undefined on timeout because we want to simply "fall back" to
    // password auth, basically just assuming the user doesn't have an external IDP.
    const response = await onAbort(() => undefined, webfingerResponse);
    const json = await response?.json();
    return extractIdpInfo(json);
  };

export function extractIdpInfo(
  webfingerResp?: WebfingerResponse,
): IdpInfo | undefined {
  const isPasswordSignInAvailable: boolean = webfingerResp?.links
    ?.map((link) => link?.properties['okta:idp:type'])
    .includes('OKTA');
  const idpList: IdpItem[] = webfingerResp?.links
    ?.map(
      (link) =>
        link?.properties?.['okta:idp:type'] &&
        link?.properties?.['okta:idp:type'] !== 'OKTA' && {
          id: link?.properties?.['okta:idp:id'],
          title: link?.titles?.['en-us'],
        },
    )
    .filter((idp) => idp);
  if (!idpList || (!isPasswordSignInAvailable && idpList.length === 0)) {
    return undefined;
  }
  return {
    idpList,
    isPasswordSignInAvailable,
  };
}
